import { StateHandlerRegistry } from './registry';

export class ReduxArrayStateHandler {
  constructor(baseActionName, stateKey) {
    this._stateKey = stateKey;
    this._addActionName = `data/${baseActionName}/ADD`;
    this._removeActionName = `data/${baseActionName}/REMOVE`;
    this._clearActionName = `data/${baseActionName}/CLEAR`;
    this._setActionName = `data/${baseActionName}/SET`;

    this.selector = this.selector.bind(this);

    StateHandlerRegistry.singleton.register({
      actionName: this._addActionName,
      handleAction: this.handleAdd.bind(this),
    });

    StateHandlerRegistry.singleton.register({
      actionName: this._removeActionName,
      handleAction: this.handleRemove.bind(this),
    });

    StateHandlerRegistry.singleton.register({
      actionName: this._clearActionName,
      handleAction: this.handleClear.bind(this),
    });

    StateHandlerRegistry.singleton.register({
      actionName: this._setActionName,
      handleAction: this.handleSet.bind(this),
    });
  }

  add(value) {
    return {
      type: this._addActionName,
      payload: value,
    };
  }

  remove(value) {
    return {
      type: this._removeActionName,
      payload: value,
    };
  }

  clear() {
    return {
      type: this._clearActionName,
    };
  }

  set(value) {
    return {
      type: this._setActionName,
      payload: value,
    };
  }

  selector(state) {
    const key = this._stateKey;
    return state[key];
  }

  handleAdd(state, action) {
    const key = this._stateKey;
    const existingValue = state[key] || [];
    state[this._stateKey] = [...existingValue, action.payload];
  }

  handleRemove(state, action) {
    const key = this._stateKey;
    const existingValue = state[key] || [];
    state[this._stateKey] = existingValue.filter(
      (value) => value !== action.payload,
    );
  }

  handleClear(state) {
    state[this._stateKey] = [];
  }

  handleSet(state, action) {
    state[this._stateKey] = action.payload;
  }

}
